import styled from 'styled-components';
import { lightGrey2Color } from 'js/config/style';
import { defaultPadding } from 'js/components/core/Backdrop';

export default styled.div`
  margin-top: ${defaultPadding};
  border: 1px solid ${lightGrey2Color};
  border-radius: 0.5rem;
  font-size: 0.9rem;
  position: relative;
  padding: 1rem;
`;
